module.exports = __webpack_public_path__ + "img/d_6.4aad4717.png";